const info_data = [
    {
        id : "1",
        title : "BeasiswaQu",
        desc : "Berada di bawah Yayasan Beasiswa Quran Indonesia",
        img : 'BeasiswaQu.png'
    },
    {
        id : "2",
        title : "Kesempatan Belajar",
        desc : "Memberikan kesempatan kepada putra-putri terbaik bangsa untuk mengenyam pendididkan",
        img : 'Kesempatan-Belajar.png'
    },
    {
        id : "3",
        title : "Meraih Cita-Cita",
        desc : "Mengulurkan tangan kepada orang di sekitar kita yang sedang bermimpi serta berusaha untuk meraih cita-cita",
        img : 'Meraih-Cita-Cita.png'
    },
    {
        id : "4",
        title : "Mencerdaskan Bangsa",
        desc : "Mencerdaskan kehidupan bangsa Indonesia dengan memberikan beasiswa",
        img : 'Mencerdaskan-Bangsa.png'
    },
    {
        id : "5",
        title : "Meningkatkan Mutu Pendidikan",
        desc : "membuka wadah untuk para pendidik agar mau melanjutkan kembali pendidikannya serta pengetahuannya. Sehingga pengetahuannya akan terus berkembang dan lebih maju lagi.",
        img : 'Meningkatkan-Mutu-Pendidikan.png'
    },
    {
        id : "6",
        title : "Hak Warga Negara",
        desc : "Program BeasiswaQu terpanggil untuk mewujudkan cita-cita dalam pembukaan UUD 1945, bahwa setiap warga berhak mendapat pendidikan",
        img : 'Hak-Warga-Negara.png'
    },
    {
        id : "7",
        title : "Meringankan Kesulitan",
        desc : "Membantu warga negara yang tidak mampu mengenyam pendidikan karena masalah perekonomian.",
        img : 'Meringankan-Kesulitan.png'
    },
    {
        id : "8",
        title : "Saling Membantu",
        desc : "Memberikan bantuan kepada single parent ataupun yatim piatu yang membutuhkan bantuan dana pendidikan untuk sekolahnya.",
        img : 'Saling-Membantu.png'
    },
    {
        id : "9",
        title : "Mencapai Indoensia Maju",
        desc : "Menggapai Indonesia cerdas dan kompetitifi, pengetahuan yang luas serta keterampilan yang terasah.",
        img : 'Mencapai-Indonesia-Maju.png'
    },
];

export default info_data;